/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const RequestProductionAccessBody = zod
	.object({
		message: zod.string().describe('Reason for requesting production access')
	})
	.describe('Production access request');

export type RequestProductionAccessBody = zod.input<typeof RequestProductionAccessBody>;
export type RequestProductionAccessBodyOutput = zod.output<typeof RequestProductionAccessBody>;
